import { render, staticRenderFns } from "./metrics_teachers_sidebar.vue?vue&type=template&id=64876c4c&scoped=true&"
import script from "./metrics_teachers_sidebar.vue?vue&type=script&lang=js&"
export * from "./metrics_teachers_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./metrics_teachers_sidebar.vue?vue&type=style&index=0&id=64876c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64876c4c",
  null
  
)

export default component.exports